import { useState } from 'react';
import Modal from '@mui/material/Modal';
import ErrorHandler from '@Root/ErrorHandler';
import { IoClose as Close } from 'react-icons/io5';
import { ReactComponent as DeleteIcon } from '@Assets/delete.svg';
import FolderIcon from '@mui/icons-material/Folder';
import BorderWhiteButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderWhiteButtonV2';
import BorderRedButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderRedButtonV2';
import { useReduxProject } from '@Hooks/reduxProjectHook/useReduxProject';
import ProjectFolderService from '@Helpers/URLHelpers/ProjectFolderService';
import './DeleteProjectFolderForm.scss';


export default function DeleteProjectFolderForm(props) {

    const [cursor, setCursor] = useState('auto');
    const { currentProjectId } = useReduxProject();
    const projectFolderService = new ProjectFolderService();
    const errorHandler = new ErrorHandler();
    const className = 'deleteProjectFolderForm';

    const handleFolderDelete = async(e)=> {
        e.preventDefault();
        setCursor('wait');
        try {
            let parentId = props.navigationParentId === 0 ? currentProjectId : props.navigationParentId;
            let bodyObj = {
                folderId: props.folderId,
                folderName: props.folderName,
            }
            await projectFolderService.deleteProjectFolder(bodyObj);
            await props.renderData(parentId);
        } catch(err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
        props.closePopup();
    };

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            style={{ cursor: cursor }}
            className={className}>
                <div className={className + '__inner flex-column-flex-start'}>
                    <div className={className + '__inner__titleBar width-wfa'}>
                        <div className={className + '__inner__titleBar__title flex-row-center-0p5rem-gap'}>
                            <FolderIcon className={className + '__inner__titleBar__title__tag grey-text'} />
                            <div className={className + '__inner__titleBar__title__t1 flex-row-flex-end standard-text-semi-large red-text semi-bold-text'}>
                                <DeleteIcon className={className + '__inner__titleBar__title__t1__icon'} />
                                Delete Folder
                            </div>
                        </div>
                        <Close className={className + '__inner__titleBar__close close-button'} onClick={props.closePopup} />
                    </div>
                    <div className={className + '__inner__name flex-column-flex-start'}>
                        <div className={className + '__inner__name__tag large-text'}>
                            {props.folderName}
                        </div>
                    </div>
                    <form className={className + '__inner__form flex-column-flex-start width-wfa'} onSubmit={handleFolderDelete}>
                        <div className={className + '__inner__form__info flex-column-flex-start'}>
                            <div className={className + '__inner__form__info__t1'}>Are you sure you want to delete this folder?</div>
                            <div className={className + '__inner__form__info__t2 grey-text small-text'}>All the data and content in this folder will be permanently deleted and cannot be recovered.</div>
                        </div>
                        <div className={className + '__inner__form__buttonFlex flex-row-center-1rem-gap width-wfa'}>
                            <div className={className + '__inner__form__buttonFlex__delete width-wfa'}>
                                <BorderRedButtonV2
                                    text='Delete'
                                    onClick={handleFolderDelete}
                                    disabled={cursor === 'wait'}/>
                            </div>
                            <div className={className + '__inner__form__buttonFlex__cancel width-wfa'}>
                                <BorderWhiteButtonV2
                                    text='Cancel'
                                    onClick={props.closePopup}
                                    disabled={cursor === 'wait'}/>
                            </div>
                        </div>
                    </form>
                </div>
        </Modal>
    );
}
